@if(this.setSidebarListItem != undefined){
    @if (isMobile) {
        @if (isChild) {
            <div [ngClass]="{'max-h-0 !mt-0': setSidebarListItem.collapsed, 'max-h-64': !setSidebarListItem.collapsed}"
                 class="mt-2 flex flex-col overflow-hidden font-medium">
                <div routerLinkActive="!text-sidebar-link-hover font-bold"
                     [routerLink]="[link]"
                     class="group my-1 ml-[2.27rem] box-border flex cursor-pointer flex-row items-start whitespace-normal pr-4 text-xs text-sidebar-link no-underline"
                     (click)="sidebarLinkClicked.emit()">
                    <bizz-icon [hover]="true" [iconLibrary]="setSidebarListItem.Icon.Library" [iconName]="setSidebarListItem.Icon.Name"
                               routerLinkActive="activeElement !text-sidebar-link-hover"
                               class="mr-2.5 size-3.5 min-w-3.5 resize-none text-sidebar-icon group-hover:text-sidebar-link-hover">
                    </bizz-icon>
                    <p class="group-hover:text-sidebar-link-hover">{{ setSidebarListItem.Name }}</p>
                </div>
            </div>
        }@else{
            <a class='group flex text-sidebar-header flex-row gap-4'
               [class.!text-sidebar-link-hover.font-bold]="newTableViewRecordLinkActive"
               [routerLink]="[link]"
               routerLinkActive="activeElement !text-sidebar-link-hover font-bold"
               (click)="sidebarLinkClicked.emit()">
                <bizz-icon
                        class="size-6 min-w-6 text-sidebar-icon group-hover:text-sidebar-link-hover"
                        [iconLibrary]="setSidebarListItem.Icon.Library"
                        [iconName]="setSidebarListItem.Icon.Name"
                        routerLinkActive="!text-sidebar-link-hover"
                        [hover]="true">
                </bizz-icon>
                <p class="text-base !text-md no-underline group-hover:text-sidebar-link-hover"
                   routerLinkActive="!text-sidebar-link-hover"
                   [ngClass]="{'max-h-5': !setSidebarListItem.collapsed, 'max-h-64': !setSidebarListItem.collapsed}">
                    {{ setSidebarListItem.Name }}
                </p>
            </a>
        }
    } @else {
        @if (isChild) {
            <div class="group flex cursor-pointer items-start whitespace-normal text-xs text-sidebar-link no-underline"
                 [routerLink]="[link]"
                 (click)="sidebarLinkClicked.emit()" routerLinkActive="activeElement !text-sidebar-link-hover font-bold">
                <bizz-icon
                        class="mr-2.5 mt-0.5 size-3.5 min-w-3.5 resize-none text-sidebar-icon group-hover:text-sidebar-link-hover"
                        [iconLibrary]="setSidebarListItem.Icon.Library" [iconName]="setSidebarListItem.Icon.Name"
                        routerLinkActive="!text-sidebar-link-hover" [hover]="true">
                </bizz-icon>
                <p class="group-hover:text-sidebar-link-hover">{{ setSidebarListItem.Name }}</p>
            </div>
        } @else {
            <a class='group flex gap-4 text-sidebar-header hover:text-sidebar-link-hover'
               [class.!text-sidebar-link-hover.font-bold]="newTableViewRecordLinkActive"
               [routerLink]="[link]"
               routerLinkActive="activeElement !text-sidebar-link-hover font-bold"
               (click)="sidebarLinkClicked.emit()">
                <bizz-icon
                        class="mt-0.5 size-6 min-w-[1.25rem] text-sidebar-icon group-hover:text-sidebar-link-hover sm:size-5"
                        [iconLibrary]="setSidebarListItem.Icon.Library"
                        [iconName]="setSidebarListItem.Icon.Name"
                        routerLinkActive="!text-sidebar-link-hover"
                        [hover]="true">
                </bizz-icon>
                <p class="text-base no-underline group-hover:text-sidebar-link-hover sm:text-sm"
                   [ngClass]="{'max-h-64': !setSidebarListItem.collapsed, 'overflow-hidden': !(expanded | async)}">
                    {{ setSidebarListItem.Name }}
                </p>
            </a>
        }
    }
}


